/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */

import ServiceConstant from "@/app/core/ServiceConstant";
import MainService from "@/app/services/MainService";
import ServicePath from "@/core/ServicePath";
export default class AudiometryHistoryService extends MainService {
  static listAllPagination(params) {
    return this.postSEC(
      ServiceConstant.AUDIOMETRY_LISTALLHISTORY_PAGINATION,
      params
    );
  }
  static get(params) {
    return this.postSEC(ServiceConstant.AUDIOMETRY_GET_HISTORY, params);
  }
  static update(params) {
    return this.postSEC(ServiceConstant.AUDIOMETRY_UPDATE, params);
  }

  static pdf(params) {
    return this.postPDFSEC(ServicePath.AUDIOMETRY_PDF, params);
  }
  static excel(params) {
    return this.postPDFSEC(ServiceConstant.AUDIOMETRY_EXCEL, params);
  }
  static productivity(params) {
    return this.postPDFSEC(ServicePath.AUDIOMETRY_EXCELPRODUCTIVITY, params);
  }
}
